<template>
  <v-tooltip bottom>
    <template v-slot:activator="{ on: tooltip, attrs }">
      <span v-on="{ ...tooltip }" v-bind="{ ...attrs }">
        <v-btn
          v-bind="{ ...$attrs }"
          v-on="{ ...$listeners }"
          :disabled="workspaceMastersNumberMaxReached"
          icon
          color="master"
          class="mx-1"
          @click.stop="masterDuplicate"
        >
          <v-icon>mdi-content-duplicate</v-icon>
        </v-btn>
      </span>
    </template>
    <span v-if="workspaceMastersNumberMaxReached">
      Sorry, you have reached the maximum number ({{
        userLogged.usageLimits.workspaceMastersNumberMax
      }}) of models per workspace allowed by your current plan; contact us to extend this limit
    </span>
    <span v-else>Duplicate this model</span>
  </v-tooltip>
</template>

<script>
import { mapState, mapMutations } from 'vuex'
import Logger from '@/lib/Logger'

import ClMaster from '@/models/ClMaster'

export default {
  props: {
    master: {
      type: Object,
      required: true,
    },
  },

  data: () => ({
    //
  }),

  computed: {
    workspaceMastersNumberMaxReached() {
      return !this.master.actionsAllowed?.selfDuplicate
    },
    ...mapState({
      userLogged: state => state.userLogged,
    }),
  },

  methods: {
    async masterDuplicate() {
      Logger.debug('masterDuplicate: ', this.master)
      // const masterNew = {
      //   title: 'Copy of' + this.master.title,
      //   masterToDuplicateId: this.master.id,
      // }
      try {
        const masterNewRes = await ClMaster.duplicate(this.master)
        this.toastSet({
          message: 'Model succesfully duplicated',
          color: 'success',
        })
        // this.$router.push({ name: 'Master', params: { masterId: masterNewId } })
        this.$router.push({ path: '/model/' + masterNewRes.id })
      } catch (e) {
        Logger.error(e)
        if (e.name === 'TITLE_ALREADY_PRESENT') {
          this.toastSet({
            message: 'Error: a model with such title already exists in this workspace',
            color: 'error',
          })
        } else {
          this.toastSet({
            message: 'Error in updating model title',
            color: 'error',
          })
        }
      }
    },
    ...mapMutations(['toastSet']),
  },
}
</script>
